<template>
    <transition name="fade-translate" appear>
        <div class="field-wrapper">
        <div class="container">
            <h2 class="league-create-title">Kreiraj svoju grupu i pozovi prijatelje i članove obitelji.</h2>
            <p class="league-create-p">
                Potrebno je samo da svojoj grupu izabereš ime i - to je to. Dobit ćeš jedinstveni link preko kojeg se svi koje pozoveš mogu priključiti grupu.
            </p>
            <form action="/" class="league-create-title-form" @submit.prevent>
                <label for="groupName">ime tvoje grupe</label>
                <input name="groupName" type="text" v-model="groupName">
            </form>
        </div>
        <a href="#" @click.prevent="createUserGroup()" class="button-1 red">
            <span>KREIRAJ GRUPU</span>
        </a>
        <ErrorMessageText v-if="error" :message="errorMessage"></ErrorMessageText>
        </div>
    </transition>
</template>

<script>
import ErrorMessageText from './../common/error/ErrorMessageText'

export default {
    name: 'kreirajgrupufield',
    data: function () {
        return {
            groupName: '',
            error: false,
            errorMessage: 'Ime tvoje lige je prazno ili neispravno.',
            creatingNewGroup: false
        }
    },
    components: {
        ErrorMessageText
    },
    methods: {
        validateGroupName () {
            // if the leauge name is not empty
            if (this.groupName) {
                // has more then 2 charachters
                if (this.groupName.length > 0 && this.groupName.length >= 3) {
                    // Does not start with a number
                    if (isNaN(parseInt(this.groupName[0]))) {
                        let regex = RegExp('^[a-zA-Z0-9_šđčćžŠĐČĆŽ]*$')
                        /**
                         * Check if the name contains only letters and croatian
                         * chars and number, no emoji or anything else
                         */
                        if (regex.test(this.groupName.replace(' ', ''))) {
                            return true
                        }
                        if (this.groupName.length < 22) {
                            return true
                        }
                    }
                }
            }
            return false
        },
        async createUserGroup () {
            if (!this.creatingNewGroup) {
                this.creatingNewGroup = true
                this.error = !this.validateGroupName()
                if (!this.error) {
                    let data = await this.$db.grupe.createUserGroup({ name: this.groupName })
                    if (data.success === true) {
                        this.$store.commit('setUserDataVlasnikGrupe', data.groupId)
                        this.error = false
                    }
                    data.groupName = this.groupName
                    this.$emit('data', data)
                }
                this.creatingNewGroup = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .container {
        text-align: left;
        margin-bottom: 30px;
    }
    .error-message {
        width: 90%;
        margin: 0 auto;
        padding: 10px;
        margin-top: 10px;
        /deep/ h3 {
            font-weight: 900;
        }
        /deep/ li {
            color: white;
        }
    }
</style>
